<template>
  <SelectDepartmentDialog
    :dialogTitle="dialogTitle"
    :centerDialogVisible="visible"
    @updateVisible="updateVisible"
    @resetPopupData="resetPopupData"
    @submitPopupData="submitPopupData"
    :popupWidth="'600px'"
  >
    <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>

    <el-tree
      class="filter-tree"
      :data="treeData"
      :props="defaultProps"
      default-expand-all
      :filter-node-method="filterNode"
      ref="tree"
      @node-click="handleNodeClick"
      @check="handleCheck"
      node-key="orgId"
      highlight-current
      :expand-on-click-node="false"
    ></el-tree>
  </SelectDepartmentDialog>
</template>

<script>
import SelectDepartmentDialog from '@/modules/projectA/components/common/e-dialog';
import Api from '@/modules/projectA/api/purchase';
export default {
  name: 'selectDepartmentDialog',
  components: {
    SelectDepartmentDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      dialogTitle: '组织机构',
      filterText: '',
      defaultProps: {
        children: 'childList',
        label: 'shortFullName',
      },
      treeData: [],
      currentNode: [],
    };
  },
  computed: {},
  created() {
    this.getDepartmentTree();
  },
  methods: {
    updateVisible() {},
    resetPopupData() {
      this.$emit('close');
    },
    submitPopupData() {
      console.log(this.currentNode);
      this.$emit('getNode', this.currentNode);
      this.$emit('close');
    },
    async getDepartmentTree() {
      let res = await Api.getSelectTreeHasStop();
      console.log(res);
      this.treeData = [res.data];
      // Api.queryDepartmentTree()
      //     .then((res) => {
      //         this.data.push(res.data)
      //     })
    },
    handleNodeClick(data) {
      this.currentNode = data;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.shortFullName.indexOf(value) !== -1;
    },
    handleCheck(a, b) {
      if (b.checkedKeys.length > 0) {
        this.$refs.tree.setCheckedKeys([a.companyId]);
      }
    },
  },
};
</script>

<style scoped>
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #409eff !important;
}
</style>
